// add title attribute to pagination links
if (jQuery('a.page-numbers.next').length) {
  jQuery('a.page-numbers.next').attr('title', 'Next page');
}
if (jQuery('a.page-numbers.prev').length) {
  jQuery('a.page-numbers.prev').attr('title', 'Previous page');
}
